import { DataGrid, GridCallbackDetails, GridColumnHeaderParams, GridColumnResizeParams, GridCsvExportOptions, GridCsvGetRowsToExportParams, GridToolbarContainer, MuiEvent, gridExpandedSortedRowIdsSelector, useGridApiContext } from '@mui/x-data-grid';
import * as React from 'react';
import $ from "jquery";
import Common from '../utilities/common';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import { Alert, Button, ButtonProps, Divider, FormControlLabel, Grid, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Radio, RadioGroup, Tooltip, Typography } from '@mui/material';
import RepairTIpoVia from './RepairTIpoVia';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import RepairMunicipio from './RepairMunicipio';
import SettingsSuggestOutlinedIcon from '@mui/icons-material/SettingsSuggestOutlined';
import RepairCodigoPostal from './RepairCodigoPostal';
import RepairNombre from './RepairNombre';
import Man2OutlinedIcon from '@mui/icons-material/Man2Outlined';
import Woman2OutlinedIcon from '@mui/icons-material/Woman2Outlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import EditRoadOutlinedIcon from '@mui/icons-material/EditRoadOutlined';
import AddRoadOutlinedIcon from '@mui/icons-material/AddRoadOutlined';
import VillaOutlinedIcon from '@mui/icons-material/VillaOutlined';
import HolidayVillageOutlinedIcon from '@mui/icons-material/HolidayVillageOutlined';
import MedicalInformationOutlinedIcon from '@mui/icons-material/MedicalInformationOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import WcOutlinedIcon from '@mui/icons-material/WcOutlined';
import RepairSexo from './RepairSexo';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import SafetyDividerOutlinedIcon from '@mui/icons-material/SafetyDividerOutlined';
import MarkunreadMailboxOutlinedIcon from '@mui/icons-material/MarkunreadMailboxOutlined';
import MyLocationOutlinedIcon from '@mui/icons-material/MyLocationOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import RepairNombreVia from './RepairNombreVia';

const getFilteredRows = ({ apiRef }: GridCsvGetRowsToExportParams) =>
    gridExpandedSortedRowIdsSelector(apiRef);

const CustomToolbar = () => {
    const apiRef = useGridApiContext();
  
    const handleExport = (options: GridCsvExportOptions) =>
      apiRef.current.exportDataAsCsv(options);
  
    const buttonBaseProps: ButtonProps = {
      color: 'primary',
      size: 'small',
      startIcon: <FileDownloadOutlinedIcon />,
    };
  
    return (
      <GridToolbarContainer>
        <Button
          {...buttonBaseProps}
          onClick={() => handleExport({ getRowsToExport: getFilteredRows, fileName: `normalizazion` })}
        >
          Exportar CSV
        </Button>
      </GridToolbarContainer>
    );
}

export interface IResultTableProps {
    normalization: any;
    filterKey?: string;
    filterError?: boolean;
}

export interface IResultTableState {
    data: any[];
    filteredData: any[];
    openTipoViaDialog: boolean;
    tipoViaValue: string;
    selectedItemId: number;
    municipioValue: string;
    nombrePilaValue: string;
    nombreVia: string;
    openMunicipioDialog: boolean;
    openCodigoPostalDialog: boolean;
    openNombreDialog: boolean;
    openSexoDialog: boolean;
    openTrameroDialog: boolean;
    filterKey: string;
    keysWithErrors: string[];
    loading: boolean;
    tiposVia: any[];
    municpios: any[];
    provincias: any[];
    columnsWidth: any[];
    normalizationProgress: any[];
    normalizationProgressErrors: any[];
}

export default class ResultTable extends React.Component<IResultTableProps, IResultTableState> {
    _filterKey: string = '';
    _filterError: boolean = true;

    public constructor(props: IResultTableProps) {
        super(props);

        this.state = {
            data: [],
            filteredData: [],
            openTipoViaDialog: false,
            tipoViaValue: '',
            openMunicipioDialog: false,
            municipioValue: '',
            selectedItemId: -1,
            openCodigoPostalDialog: false,
            openNombreDialog: false,
            openSexoDialog: false,
            openTrameroDialog: false,
            nombrePilaValue: '',
            nombreVia: '',
            filterKey: '',
            keysWithErrors: [],
            loading: false,
            tiposVia: [],
            municpios: [],
            provincias: [],
            columnsWidth: [],
            normalizationProgress: [],
            normalizationProgressErrors: []
        }
    }

    componentWillReceiveProps(nextProps: Readonly<IResultTableProps>, nextContext: any): void {
        this._filterKey = nextProps.filterKey!;
        this._filterError  = nextProps.filterError!;
        this.Get();
        this.GetProgress();
    }

    componentDidMount(): void {
        this.GetTiposVia();
        this.GetProvincias();
        this.GetMunicipios();
        this.Get();
        this.GetProgress();
    }

    public render(): React.ReactElement<{}> {
        return (
            <React.Fragment>
                {
                    this.props.normalization != null && this.props.normalization.status != 'Activo' && this.state.keysWithErrors.length > 0 && (
                        <Grid container style={{marginBottom: '20px'}}>
                            <Grid item xs={1}>
                                <Typography variant='body2' style={{position: 'relative', top:'10px', fontWeight: '600'}}>
                                    Filtrar errores:
                                </Typography>
                            </Grid>
                            <Grid item xs={11} style={{textAlign: 'right'}}>
                                <RadioGroup row name='keysWithErrors' onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    const value = (event.target as HTMLInputElement).value;
                                    this.FilterData(value);
                                }}>
                                {
                                    this.state.keysWithErrors.map((key: any, index: number) => {
                                        return (
                                            <FormControlLabel value={key.campo} defaultChecked={this.state.filterKey == key.campo} control={<Radio />} label={Common.GetDataFieldDisplayName(key.campo)} key={index} />
                                        )
                                    })
                                }
                                <FormControlLabel value='all' control={<Radio />} label='Mostrar todos' />
                                </RadioGroup>
                            </Grid>
                        </Grid>
                    )
                }
                {
                    this.props.normalization.status == 'Consolidada' && (
                        <Alert severity='info' style={{marginBottom: '20px'}}>
                            Los datos que se muestram a continuación corresponden a los datos ya consolidados
                        </Alert>
                    )
                }
                {
                    (this.state.filteredData.length > 0 || this.state.data.length > 0) && (
                        <DataGrid
                            slots={{ toolbar: CustomToolbar }}
                            slotProps={{ pagination: { labelRowsPerPage: 'Filas por página' } }}
                            autoHeight
                            rows={this.state.filteredData.length > 0 ? this.state.filteredData : this.state.data}
                            disableColumnFilter
                            disableColumnSorting
                            disableColumnMenu
                            loading={this.state.loading}
                            onColumnResize={(params: GridColumnResizeParams, event: MuiEvent, details: GridCallbackDetails) => {
                                const columnsWidth = this.state.columnsWidth;
                                const colWidth = columnsWidth.find((a) => {
                                    return a.field == params.colDef.field;
                                });

                                if(colWidth == null) {
                                    columnsWidth.push(
                                        {
                                            field: params.colDef.field,
                                            width: params.width
                                        }
                                    );
                                }
                                else {
                                    colWidth.width = params.width;
                                }

                                this.setState(
                                    {
                                        columnsWidth: columnsWidth
                                    }
                                );
                            }}
                            columns={[
                                { 
                                    field: 'telefono', 
                                    headerName: 'Telefono' ,
                                    width: this.GetColumnWidth('telefono'),
                                    renderCell: ({ row }) => (
                                        this.RenderCell(row, 'telefono')
                                    )
                                },
                                { 
                                    field: 'nombre', 
                                    headerName: 'Nombre',
                                    width: this.GetColumnWidth('nombre'),
                                    renderCell: ({ row }) => (
                                        this.RenderCell(row, 'nombre')
                                    )
                                },
                                { 
                                    field: 'apellidos', 
                                    headerName: 'Apellidos',
                                    width: this.GetColumnWidth('apellidos'),
                                    renderCell: ({ row }) => (
                                        this.RenderCell(row, 'apellidos')
                                    )
                                },
                                { 
                                    field: 'tipoVia', 
                                    headerName: 'Tipo de vía',
                                    width: this.GetColumnWidth('tipoVia'),
                                    renderCell: ({ row }) => (
                                        this.RenderCell(row, 'tipoVia')
                                    )
                                },
                                { 
                                    field: 'nombreVia', 
                                    headerName: 'Nombre de la vía',
                                    width: this.GetColumnWidth('nombreVia'),
                                    renderCell: ({ row }) => (
                                        this.RenderCell(row, 'nombreVia')
                                    )
                                },
                                { 
                                    field: 'numeroVia', 
                                    headerName: 'Número de la vía',
                                    width: this.GetColumnWidth('numeroVia'),
                                    renderCell: ({ row }) => (
                                        this.RenderCell(row, 'numeroVia')
                                    )
                                },
                                { 
                                    field: 'restoDireccion', 
                                    headerName: 'Resto de dirección',
                                    width: this.GetColumnWidth('restoDireccion'),
                                    renderCell: ({ row }) => (
                                        this.RenderCell(row, 'restoDireccion')
                                    )
                                },
                                { 
                                    field: 'cp', 
                                    headerName: 'CP',
                                    width: this.GetColumnWidth('cp'),
                                    renderCell: ({ row }) => (
                                        this.RenderCell(row, 'cp')
                                    )
                                },
                                { 
                                    field: 'municipio', 
                                    headerName: 'Municipio',
                                    width: this.GetColumnWidth('municipio'),
                                    renderCell: ({ row }) => (
                                        this.RenderCell(row, 'municipio')
                                    )
                                },
                                { 
                                    field: 'provincia', 
                                    headerName: 'Provincia',
                                    width: this.GetColumnWidth('provincia'),
                                    renderCell: ({ row }) => (
                                        this.RenderCell(row, 'provincia')
                                    )
                                },
                                { 
                                    field: 'fechaNacimiento', 
                                    headerName: 'Fecha de nacimiento',
                                    width: this.GetColumnWidth('fechaNacimiento'),
                                    renderCell: ({ row }) => (
                                        this.RenderCell(row, 'fechaNacimiento')
                                    )
                                },
                                { 
                                    field: 'email', 
                                    headerName: 'Email',
                                    width: this.GetColumnWidth('email'),
                                    renderCell: ({ row }) => (
                                        this.RenderCell(row, 'email')
                                    )
                                },
                                { 
                                    field: 'sexo', 
                                    headerName: 'Sexo',
                                    width: this.GetColumnWidth('sexo'),
                                    renderCell: ({ row }) => (
                                        this.RenderCell(row, 'sexo')
                                    )
                                },
                                { 
                                    field: 'url', 
                                    headerName: 'URL',
                                    width: this.GetColumnWidth('url'),
                                    renderCell: ({ row }) => (
                                        this.RenderCell(row, 'url')
                                    )
                                },
                                { 
                                    field: 'operador', 
                                    headerName: 'Operador',
                                    width: this.GetColumnWidth('operador'),
                                    renderCell: ({ row }) => (
                                        this.RenderCell(row, 'operador')
                                    )
                                },
                                { 
                                    field: 'cupsLuz', 
                                    headerName: 'Cups Luz',
                                    width: this.GetColumnWidth('cupsLuz'),
                                    renderCell: ({ row }) => (
                                        this.RenderCell(row, 'cupsLuz')
                                    )
                                },
                                { 
                                    field: 'cupsGas', 
                                    headerName: 'Cups Gas',
                                    width: this.GetColumnWidth('cupsGas'),
                                    renderCell: ({ row }) => (
                                        this.RenderCell(row, 'cupsGas')
                                    )
                                }
                            ]}
                            initialState={{
                                pagination: {
                                    paginationModel: { page: 0, pageSize: 30 },
                                },
                            }}
                            pageSizeOptions={[30, 60, 100]}
                            checkboxSelection={false}
                        />
                    )
                }
                <RepairTIpoVia 
                    id={this.state.selectedItemId} 
                    variacion={this.state.tipoViaValue} 
                    open={this.state.openTipoViaDialog} 
                    onCancel={() => {
                        this.setState(
                            {
                                openTipoViaDialog: false
                            }
                        )
                    }}
                    onSave={(id: number) => {
                        this.RepairTipoVia(id);
                    }}
                />
                <RepairMunicipio
                    id={this.state.selectedItemId} 
                    variacion={this.state.municipioValue} 
                    open={this.state.openMunicipioDialog} 
                    onCancel={() => {
                        this.setState(
                            {
                                openMunicipioDialog: false
                            }
                        )
                    }}
                    onSave={(id: number) => {
                        this.RepairMunicipio(id);
                    }}
                />
                <RepairCodigoPostal 
                    id={this.state.selectedItemId} 
                    open={this.state.openCodigoPostalDialog} 
                    onCancel={() => {
                        this.setState(
                            {
                                openCodigoPostalDialog: false
                            }
                        )
                    }}
                    onSave={() => {
                        this.setState(
                            {
                                openCodigoPostalDialog: false
                            }
                        );

                        this.SetProgress();
                        this.Get();
                        if(this.state.filteredData.length > 0) {
                            this.FilterData('CP');
                        }
                    }}
                />
                <RepairSexo 
                    id={this.state.selectedItemId} 
                    open={this.state.openSexoDialog} 
                    onCancel={() => {
                        this.setState(
                            {
                                openSexoDialog: false
                            }
                        )
                    }}
                    onSave={() => {
                        this.setState(
                            {
                                openSexoDialog: false
                            }
                        );

                        this.SetProgress();
                        this.GetProgress();
                        this.Get();
                    }}
                />
                <RepairNombre 
                    id={this.state.selectedItemId} 
                    variacion={this.state.nombrePilaValue}
                    open={this.state.openNombreDialog} 
                    onCancel={() => {
                        this.setState(
                            {
                                openNombreDialog: false
                            }
                        )
                    }}
                    onSave={() => {
                        this.setState(
                            {
                                openNombreDialog: false
                            }
                        );

                        this.SetProgress();
                        this.Get();
                    }}
                />
                <RepairNombreVia 
                    id={this.state.selectedItemId} 
                    nombreVia={this.state.nombreVia}
                    open={this.state.openTrameroDialog} 
                    onCancel={() => {
                        this.setState(
                            {
                                openTrameroDialog: false
                            }
                        )
                    }}
                    onSave={() => {
                        this.setState(
                            {
                                openTrameroDialog: false
                            }
                        );

                        this.SetProgress();
                        this.Get();
                    }}
                />
            </React.Fragment>
        )
    }

    private SetProgress(): void {
        const normalizationProgress = this.state.normalizationProgress;
        const progressItem = normalizationProgress.find((a) => {
            return a.normalizacionDataId == this.state.selectedItemId
        });

        if(progressItem != null) {
            progressItem.estadoId = 1;
        }

        this.setState({
            normalizationProgress: normalizationProgress
        });
    }

    private Get(): void {
        let url = `${Common.END_POINT}/normalizaciones/${this.props.normalization.id}/data`;

        if(this.props.normalization.status == "Consolidada") {
            url = `${Common.END_POINT}/normalizaciones/${this.props.normalization.id}/consolidated`;
        }
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    data: response,
                    loading: false
                }
            );
            this.GetProgressErrors();
            this.GetKeysWithErrors();
        });
    }

    private FilterData(value: string): void {
        if(value != 'all') {
            const filteredData = Common.FilterNormalizationData(this.state.normalizationProgressErrors, this.state.data, value);
            this.setState(
                {
                    filterKey: '',
                    filteredData: filteredData
                }
            );
        }
        else {
            this.setState(
                {
                    filterKey: '',
                    filteredData: []
                }
            );
        }
    }

    private GetProgress(): void {
        let url = `${Common.END_POINT}/normalizaciones/${this.props.normalization.id}/progress`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    normalizationProgress: response
                }
            );
        });
    }

    private GetProgressErrors(): void {
        let url = `${Common.END_POINT}/normalizaciones/${this.props.normalization.id}/progress/errors`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            console.log('GetProgressErrors', response);
            this.setState(
                {
                    normalizationProgressErrors: response
                }
            );
        });
    }

    private GetKeysWithErrors(): void {
        let url = `${Common.END_POINT}/normalizaciones/${this.props.normalization.id}/progress/errors/fields`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            if(response.length == 0) {
                this.setState(
                    {
                        filteredData: [],
                        keysWithErrors: response
                    }
                );
            }
            else {
                this.setState(
                    {
                        keysWithErrors: response
                    }
                );
            }
        });
    }

    private RenderHeader(params: GridColumnHeaderParams): JSX.Element {
        return (
            <React.Fragment>
                {
                    this.props.normalization.actions.toLowerCase().split(',').indexOf(params.colDef.field.toLowerCase()) > -1 && (
                        <SettingsSuggestOutlinedIcon style={{
                            fontSize: '20px',
                            position: 'relative',
                            top: '-2px',
                            color: '#EF9912'
                        }}/>
                    )
                }
                {
                    this.props.normalization.actions.toLowerCase().indexOf("nombres") > -1 && (params.colDef.field.toLowerCase() == 'nombre' || params.colDef.field.toLowerCase() == 'apellidos') && (
                        <SettingsSuggestOutlinedIcon style={{
                            fontSize: '20px',
                            position: 'relative',
                            top: '-2px',
                            color: '#EF9912'
                        }}/>
                    )
                }
                <strong style={{display: 'inline-block', marginLeft: '5px'}}>
                {
                    params.colDef.headerName
                }
                </strong>
            </React.Fragment>
        )
    }

    private RenderCell(row: any, key: string) {
        if(row[key] == null || row[key].indexOf == undefined){
            return '';
        }

        const actions = this.props.normalization.actions.toLowerCase().split(',');
        const progressError = this.state.normalizationProgressErrors.find((a) => {
            return a.normalizacionDataId == row.id && a.campo != null && (a.campo.toLowerCase() == key.toLowerCase());
        });

        return (
            <React.Fragment>
                {
                    progressError != null && (
                        <Tooltip 
                            arrow
                            componentsProps={{ tooltip: { style: {padding: '10px'} }}}
                                title={<React.Fragment>
                                    <Typography variant='body2' style={{fontWeight: 'bold', marginBottom: '10px'}}>
                                    {
                                        `${progressError.mensaje.toUpperCase()}. `
                                    }
                                    </Typography>
                                    {
                                        key == 'tipoVia' && progressError != null && progressError.estadoId != 8 && (
                                            <React.Fragment>
                                                <Typography variant='body2'>
                                                    Puede conservar este valor como válido para el registro o puede corregirlo seleccionando una de las siguientes opciones y reiniciando la normalización:
                                                </Typography>
                                                <List>
                                                    <ListItem disableGutters disablePadding>
                                                        <ListItemButton onClick={() => {
                                                            window.open('/masters/tiposvia');
                                                        }}>
                                                            <ListItemIcon>
                                                                <EditRoadOutlinedIcon style={{color: '#fff'}}/>
                                                            </ListItemIcon>
                                                            <ListItemText secondary="Crear como tipo de vía" secondaryTypographyProps={{color: '#fff'}}/>
                                                        </ListItemButton>
                                                    </ListItem>
                                                    <ListItem disableGutters disablePadding>
                                                        <ListItemButton onClick={() => {
                                                            window.open('/masters/tipoviavariaciones');
                                                        }}>
                                                            <ListItemIcon>
                                                                <AddRoadOutlinedIcon style={{color: '#fff'}}/>
                                                            </ListItemIcon>
                                                            <ListItemText secondary="Crear como variación de un tipo de vía" secondaryTypographyProps={{color: '#fff'}}/>
                                                        </ListItemButton>
                                                    </ListItem>
                                                </List>
                                            </React.Fragment>
                                        )
                                    }
                                    {
                                        key == 'tipoVia' && progressError != null && progressError.estadoId == 8 && (
                                            <React.Fragment>
                                                <Typography variant='body2'>
                                                    Puede conservar este valor como válido para el registro o puede corregirlo asignando uno de las siguientes valores:
                                                </Typography>
                                                <List>
                                                    {
                                                        progressError.valores != null && progressError.valores != '' && progressError.valores.split(",").map((value: string, index: number) => {
                                                            return (
                                                                <ListItem disableGutters disablePadding key={index}>
                                                                    <ListItemButton onClick={() => {
                                                                        this.SetTipoVia(row, value, progressError.campo);
                                                                    }}>
                                                                        <ListItemIcon>
                                                                            <EditRoadOutlinedIcon style={{color: '#fff'}}/>
                                                                        </ListItemIcon>
                                                                        <ListItemText secondary={value} secondaryTypographyProps={{color: '#fff'}}/>
                                                                    </ListItemButton>
                                                                </ListItem>
                                                            )
                                                        })
                                                    }
                                                </List>
                                            </React.Fragment>
                                        )
                                    }
                                    {
                                        key == 'nombreVia' && (
                                            <React.Fragment>
                                                {
                                                    progressError.valores != null && progressError.valores != '' && (
                                                        <React.Fragment>
                                                            <Typography variant='body2' component={'div'} style={{marginBottom: '10px'}}>
                                                                El tipo de vía no coincide con la información del tramero. Los tipos de vía vinculados al nombre de la vía son: {progressError.valores.replaceAll(',', ', ')}.
                                                            </Typography>
                                                            <Typography variant='body2' component={'div'} style={{marginBottom: '10px'}}>
                                                                Puede corregir el tipo de vía seleccionándolo en el desplegable del campo tipo de vía y conservando el valor como nombre de vía.
                                                            </Typography>
                                                        </React.Fragment>
                                                    )
                                                }
                                                {
                                                    (progressError.valores == null || progressError.valores == '') && (
                                                        <React.Fragment>
                                                            <Typography variant='body2' component={'div'}>
                                                                Puede conservar este valor como válido para el registro o puede corregirlo seleccionando una de las siguientes opciones y reiniciando la normalización:
                                                            </Typography>
                                                            <List>
                                                                    <ListItem disableGutters disablePadding>
                                                                    <ListItemButton onClick={() => {
                                                                        this.OpenTrameroDialog(row);
                                                                    }}>
                                                                        <ListItemIcon>
                                                                            <SearchOutlinedIcon style={{color: '#fff'}}/>
                                                                        </ListItemIcon>
                                                                        <ListItemText secondary='Buscar en el tramero' secondaryTypographyProps={{color: '#fff'}}/>
                                                                    </ListItemButton>
                                                                </ListItem>
                                                            </List>
                                                        </React.Fragment>
                                                    )
                                                }
                                            </React.Fragment>
                                        )
                                    }
                                    {
                                        key == 'municipio' && (
                                            <React.Fragment>
                                                <Typography variant='body2'>
                                                    Puede conservar este valor como válido para el registro o puede corregirlo seleccionando una de las siguientes opciones y reiniciando la normalización:
                                                </Typography>
                                                <List>
                                                    <ListItem disableGutters disablePadding>
                                                        <ListItemButton onClick={() => {
                                                            window.open('/masters/municipios');
                                                        }}>
                                                            <ListItemIcon>
                                                                <VillaOutlinedIcon style={{color: '#fff'}}/>
                                                            </ListItemIcon>
                                                            <ListItemText secondary="Crear como municipio" secondaryTypographyProps={{color: '#fff'}}/>
                                                        </ListItemButton>
                                                    </ListItem>
                                                    <ListItem disableGutters disablePadding>
                                                        <ListItemButton style={{color: '#fff'}} onClick={() => {
                                                            window.open('/masters/municipiosvariaciones');
                                                        }}>
                                                            <ListItemIcon>
                                                                <VillaOutlinedIcon style={{color: '#fff'}}/>
                                                            </ListItemIcon>
                                                            <ListItemText secondary="Crear como variación de un municipio" secondaryTypographyProps={{color: '#fff'}}/>
                                                        </ListItemButton>
                                                    </ListItem>
                                                </List>
                                            </React.Fragment>
                                        )
                                    }
                                    {
                                        key == 'provincia' && (
                                            <React.Fragment>
                                                <Typography variant='body2'>
                                                    Puede conservar este valor como válido para el registro o puede corregirlo seleccionando una de las siguientes opciones y reiniciando la normalización:
                                                </Typography>
                                                <List>
                                                    <ListItem disableGutters disablePadding>
                                                        <ListItemButton onClick={() => {
                                                            window.open('/masters/provincias');
                                                        }}>
                                                            <ListItemIcon>
                                                                <HolidayVillageOutlinedIcon style={{color: '#fff'}}/>
                                                            </ListItemIcon>
                                                            <ListItemText secondary="Crear la provincia" secondaryTypographyProps={{color: '#fff'}}/>
                                                        </ListItemButton>
                                                    </ListItem>
                                                    <ListItem disableGutters disablePadding>
                                                        <ListItemButton onClick={() => {
                                                            window.open('/masters/municipios');
                                                        }}>
                                                            <ListItemIcon>
                                                                <VillaOutlinedIcon style={{color: '#fff'}}/>
                                                            </ListItemIcon>
                                                            <ListItemText secondary="Crear el municipio" secondaryTypographyProps={{color: '#fff'}}/>
                                                        </ListItemButton>
                                                    </ListItem>
                                                </List>
                                            </React.Fragment>
                                        )
                                    }
                                    {
                                        key == 'nombre' && (
                                            <React.Fragment>
                                                <Typography variant='body2'>
                                                    Puede conservar este valor como válido para el registro o puede corregirlo seleccionando una de las siguientes opciones y reiniciando la normalización:
                                                </Typography>
                                                <List>
                                                    <ListItem disableGutters disablePadding>
                                                        <ListItemButton onClick={() => {
                                                            window.open('/masters/nombresdepila');
                                                        }}>
                                                            <ListItemIcon>
                                                                <BadgeOutlinedIcon style={{color: '#fff'}}/>
                                                            </ListItemIcon>
                                                            <ListItemText secondary="Crear el nombre" secondaryTypographyProps={{color: '#fff'}}/>
                                                        </ListItemButton>
                                                    </ListItem>
                                                    <ListItem disableGutters disablePadding>
                                                        <ListItemButton onClick={() => {
                                                            window.open('/masters/variacionesnombresdepila');
                                                        }}>
                                                            <ListItemIcon>
                                                                <MedicalInformationOutlinedIcon style={{color: '#fff'}}/>
                                                            </ListItemIcon>
                                                            <ListItemText secondary="Crear la variación del nombre" secondaryTypographyProps={{color: '#fff'}}/>
                                                        </ListItemButton>
                                                    </ListItem>
                                                    {
                                                        actions.indexOf('sexo') > -1 && (
                                                            <ListItem disableGutters disablePadding>
                                                                <ListItemButton onClick={() => {
                                                                    this.OpenSexoDialog(row);
                                                                }}>
                                                                    <ListItemIcon>
                                                                        <WcOutlinedIcon style={{color: '#fff'}}/>
                                                                    </ListItemIcon>
                                                                    <ListItemText secondary="Establecer sexo" secondaryTypographyProps={{color: '#fff'}}/>
                                                                </ListItemButton>
                                                            </ListItem>
                                                        )
                                                    }
                                                </List>
                                                <Typography variant='body2'>
                                                    También puede modificar este valor para el registro indicando cuáles son los nombres y apellidos:
                                                </Typography>
                                                <List>
                                                    <ListItem disableGutters disablePadding>
                                                        <ListItemButton onClick={() => {
                                                            this.OpenNombrePilaDialog(row);
                                                        }}>
                                                            <ListItemIcon>
                                                                <SafetyDividerOutlinedIcon style={{color: '#fff'}}/>
                                                            </ListItemIcon>
                                                            <ListItemText secondary="Establecer nombre y apellido en el registro" secondaryTypographyProps={{color: '#fff'}}/>
                                                        </ListItemButton>
                                                    </ListItem>
                                                </List>
                                            </React.Fragment>
                                        )
                                    }
                                    {
                                        key == 'apellidos' && (
                                            <React.Fragment>
                                                <Typography variant='body2'>
                                                Puede conservar este valor como válido para el registro o puede corregirlo seleccionando una de las siguientes opciones y reiniciando la normalización:
                                                </Typography>
                                                <List>
                                                    <ListItem disableGutters disablePadding>
                                                        <ListItemButton onClick={() => {
                                                            window.open('/masters/apellidos');
                                                        }}>
                                                            <ListItemIcon>
                                                                <BadgeOutlinedIcon style={{color: '#fff'}}/>
                                                            </ListItemIcon>
                                                            <ListItemText secondary="Crear el apellido" secondaryTypographyProps={{color: '#fff'}}/>
                                                        </ListItemButton>
                                                    </ListItem>
                                                    <ListItem disableGutters disablePadding>
                                                        <ListItemButton onClick={() => {
                                                            window.open('/masters/variacionesapellidos');
                                                        }}>
                                                            <ListItemIcon>
                                                                <MedicalInformationOutlinedIcon style={{color: '#fff'}}/>
                                                            </ListItemIcon>
                                                            <ListItemText secondary="Crear la variación del apellido" secondaryTypographyProps={{color: '#fff'}}/>
                                                        </ListItemButton>
                                                    </ListItem>
                                                </List>
                                            </React.Fragment>                                            
                                        )
                                    }
                                    {
                                        key == 'cp' && (
                                            <React.Fragment>
                                                <Typography variant='body2'>
                                                    Puede asignar el código postal en el registro seleccionando la siguiente acción:
                                                </Typography>
                                                <List>
                                                    <ListItem disableGutters disablePadding>
                                                        <ListItemButton onClick={() => {
                                                            this.OpenCodigoPostalDialog(row);
                                                        }}>
                                                            <ListItemIcon>
                                                                <MarkunreadMailboxOutlinedIcon style={{color: '#fff'}}/>
                                                            </ListItemIcon>
                                                            <ListItemText secondary="Establecer código postal" secondaryTypographyProps={{color: '#fff'}}/>
                                                        </ListItemButton>
                                                    </ListItem>
                                                </List>
                                            </React.Fragment>
                                        )
                                    }
                                </React.Fragment>}
                            >
                            <span className={this.GetErrorClass(progressError)}>
                                {
                                    progressError.estadoId == 4 && (
                                        <Alert severity="warning">
                                            {
                                                row[key]
                                            }
                                        </Alert>
                                    )
                                }
                                {
                                    progressError.estadoId == 5 && (
                                        <Alert severity="info" onClick={() => {
                                            if(key == 'nombre') {
                                                this.OpenNombrePilaDialog(row);
                                            }
                                        }}>
                                        {
                                            row[key]
                                        }
                                        </Alert>
                                    )
                                }
                                {
                                    progressError.estadoId == 3 && (
                                        <Alert severity="error" onClick={() => {
                                            if(key == 'cp') {
                                                this.OpenCodigoPostalDialog(row);
                                            }
            
                                            if(key == 'nombre') {
                                                this.OpenNombrePilaDialog(row);
                                            }
                                        }}>
                                        {
                                            row[key]
                                        }
                                        </Alert>
                                    )
                                }
                                {
                                    progressError.estadoId == 8 && (
                                        <Alert severity="warning">
                                        {
                                            row[key]
                                        }
                                        </Alert>
                                    )
                                }
                                {
                                    progressError.estadoId == 6 && (
                                        <Alert severity="warning">
                                        {
                                            row[key]
                                        }
                                        </Alert>
                                    )
                                }
                            </span>
                        </Tooltip>
                    )
                }
                {
                    row[key].indexOf != undefined && progressError == null && (
                        <React.Fragment>
                            {
                                key == 'tipoVia' && (
                                    this.GetTipoVia(row[key])
                                )
                            }
                            {
                                key == 'municipio' && (
                                    this.GetMunicipio(row[key])
                                )
                            }
                            {
                                key == 'provincia' && (
                                    this.GetProvincia(row[key])
                                )
                            }
                            {
                                key != 'tipoVia' && key != 'municipio' && key != 'provincia' && key != 'sexo' && (
                                    row[key]
                                )
                            }
                        </React.Fragment>
                    )
                }
                {
                    row[key].indexOf != undefined && progressError == null && key == 'sexo' && (
                        <React.Fragment>
                            {
                                row[key] == 'M' && (
                                    <Woman2OutlinedIcon style={{fontSize: '24px', position: 'relative', top: '6px'}}/>
                                )
                            }
                            {
                                row[key] == 'H' && (
                                    <Man2OutlinedIcon style={{fontSize: '24px', position: 'relative', top: '6px'}}/>
                                )
                            }
                        </React.Fragment>
                    )
                }
            </React.Fragment>
        )
    }

    private GetErrorClass(progressError: any): string {
        if (progressError == null) {
            return '';
        }

        if (progressError.estadoId == 5) {
            return 'duplicated';
        }

        if (progressError.estadoId == 4) {
            return 'warning';
        }

        return 'error';
    }

    private RenderIconStatus(row: any): JSX.Element {
        if(this.state.normalizationProgress.length == 0) {
            return (
                <AccessTimeOutlinedIcon/>
            )
        }
        const progressItem = this.state.normalizationProgress.find((a) => {
            return a.normalizacionDataId == row['id']
        });

        if(progressItem == undefined) {
            return (
                <div className='textCenter iconMiddle'>
                    <TaskAltOutlinedIcon color='success'/>
                </div>
            )
        }

        const estado = progressItem.estadoId;
        
        return (
            <div className='textCenter iconMiddle'>
                {
                    estado == 1 && (
                        <RefreshOutlinedIcon color='info' className='rotation'/>
                    )
                }
                {
                    estado == 2 && (
                        <TaskAltOutlinedIcon color='success'/>
                    )
                }
                {
                    estado == 3 && (
                        <ErrorOutlineOutlinedIcon color='error'/>
                    )
                }
                {
                    estado == 7 && (
                        <AccessTimeOutlinedIcon/>
                    )
                }
            </div>
        )
    }

    private RepairTipoVia(id: number) {
        this.setState(
            {
                loading: true
            }
        );

        const data: any[] = JSON.parse(JSON.stringify(this.state.data));
        const item = data.find((item: any) => {
            return item.id == id;
        });

        const error = JSON.parse(item.tipoVia);
        error.Type = 'Warning';
        item.tipoVia =  JSON.stringify(error);

        const items = data.filter((value: any) => {
            return value.tipoVia.indexOf != undefined && value.tipoVia.indexOf("Message") > -1 && JSON.parse(value.tipoVia).Value == JSON.parse(item.tipoVia).Value
        });

        for(let i = 0; i < items.length; i++) {
            const item = items[i];
            if (item.tipoVia.indexOf("Message")) {
                const error = JSON.parse(item.tipoVia);
                error.Type = 'Warning';
                item.tipoVia =  JSON.stringify(error);
            }
        }

        const filterKey = this.state.filterKey;

        let filteredData: any[] = [];
        if(this.state.filteredData.length > 0) {
            filteredData = data.filter((value: any) => {
                if(filterKey != '' && filterKey != null && filterKey != 'all') {
                    if(value[filterKey].indexOf != undefined && value[filterKey].indexOf('Message') > -1) {
                        return value;
                    }
                }
                else {
                    for(let key in value) {
                        if(value[key].indexOf != undefined && value[key].indexOf('Message') > -1) {
                            return value;
                        }
                    }
                }
            });
        }

        this.setState({
            data: data,
            filteredData: filteredData,
            openTipoViaDialog: false,
            loading: false
        });
    }

    private RepairMunicipio(id: number) {
        this.setState(
            {
                loading: true
            }
        );

        const data: any[] = JSON.parse(JSON.stringify(this.state.data));
        const item = data.find((item: any) => {
            return item.id == id;
        });

        const items = data.filter((value: any) => {
            return value.municipio.indexOf != undefined && value.municipio.indexOf("Message") > -1 && JSON.parse(value.municipio).Value == JSON.parse(item.municipio).Value
        });

        for(let i = 0; i < items.length; i++) {
            const item = items[i];
            if (item.municipio.indexOf("Message")) {
                const error = JSON.parse(item.municipio);
                error.Type = 'Warning';
                item.municipio =  JSON.stringify(error);
            }
        }

        const filterKey = this.state.filterKey;

        let filteredData: any[] = [];
        if(this.state.filteredData.length > 0) {
            filteredData = data.filter((value: any) => {
                if(filterKey != '' && filterKey != null && filterKey != 'all') {
                    if(value[filterKey].indexOf != undefined && value[filterKey].indexOf('Message') > -1) {
                        return value;
                    }
                }
                else {
                    for(let key in value) {
                        if(value[key].indexOf != undefined && value[key].indexOf('Message') > -1) {
                            return value;
                        }
                    }
                }
            });
        }

        this.setState({
            data: data,
            filteredData: filteredData,
            openMunicipioDialog: false,
            loading: false
        });
    }

    private OpenCodigoPostalDialog(row: any) {
        this.setState({
            openCodigoPostalDialog: true,
            selectedItemId: row['id']
        });
    }

    private OpenSexoDialog(row: any) {
        this.setState({
            openSexoDialog: true,
            selectedItemId: row['id']
        });
    }

    private OpenNombrePilaDialog(row: any) {
        this.setState({
            openNombreDialog: true,
            nombrePilaValue: row['nombre'],
            selectedItemId: row['id']
        });
    }

    private OpenTrameroDialog(row: any) {
        this.setState({
            openTrameroDialog: true,
            nombreVia: row['nombreVia'],
            selectedItemId: row['id']
        });
    }

    private GetTiposVia(): void {
        this.setState({
            loading: true
        });

        let url = `${Common.END_POINT}/masters/tiposVia`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    tiposVia: response
                }
            );
        })
    }

    private GetTipoVia(value: string): string {
        const tiposVia = this.state.tiposVia;
        const tipoVia = tiposVia.find((a: any) => {
            return a.id == value;
        });

        if(tipoVia == null) {
            return value;
        }

        return tipoVia.nombre;
    }

    private GetMunicipios(): void {
        this.setState({
            loading: true
        });

        let url = `${Common.END_POINT}/masters/Municipios`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    municpios: response
                }
            );
        })
    }

    private GetMunicipio(value: string): string {
        const municipios = this.state.municpios;
        const municpio = municipios.find((a: any) => {
            return a.id == value;
        });

        if(municpio == null) {
            return value;
        }

        return municpio.nombre;
    }

    private GetProvincias(): void {
        this.setState({
            loading: true
        });

        let url = `${Common.END_POINT}/masters/Provincias`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    provincias: response
                }
            );
        })
    }

    private GetProvincia(value: string): string {
        const provincias = this.state.provincias;
        const provincia = provincias.find((a: any) => {
            return a.id == value;
        });

        if(provincia == null) {
            return value;
        }

        return provincia.nombre;
    }

    private GetColumnWidth(field: string): number {
        const actions = this.props.normalization.actions.toLowerCase().split(',');
        
        if((actions.indexOf(field.toLowerCase()) > -1 || ((actions.indexOf("nombres") > -1 && field.toLowerCase() == 'nombre') || (actions.indexOf("nombres") > -1 && field.toLowerCase() == 'apellidos')))) {
            return 220;
        }

        if(actions.indexOf('cp') > -1) {
            if(field.toLowerCase() == 'tipovia') {
                return 200;
            }
            if(field.toLowerCase() == 'municipio') {
                return 220;
            }
            if(field.toLowerCase() == 'provincia') {
                return 200;
            }
        }

        if(actions.indexOf('sexo') > -1) {
            if(field.toLowerCase() == 'nombre') {
                return 220;
            }
        }

        if(actions.indexOf('direcciones') > -1) {
            if(field.toLowerCase() == 'tipovia') {
                return 400;
            }
            if(field.toLowerCase() == 'nombrevia') {
                return 400;
            }
            if(field.toLowerCase() == 'municipio') {
                return 400;
            }
            if(field.toLowerCase() == 'provincia') {
                return 200;
            }
        }

        const columns = this.state.columnsWidth;
        const column = columns.find((a) => {
            return a.field == field;
        });

        if(column == null) {
            return 100;
        }
        else {
            return column.width;
        }
    }

    private SetTipoVia(row: any, tipoVia: string, field: string) {
        let url = `${Common.END_POINT}/normalizaciones/data/${row['id']}`;

        $.ajax((
            {
                url: url,
                type: "GET",
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            const normalizacionItem = JSON.parse(JSON.stringify(response[0]));
            normalizacionItem.tipoVia = tipoVia;

            if(normalizacionItem.fechaNacimiento == null || normalizacionItem.fechaNacimiento.indexOf == undefined) {
                normalizacionItem.fechaNacimiento = '';
            }

            this.SaveTipoVia(row['id'], normalizacionItem, field);
        })
    }

    private SaveTipoVia(id: number, normalizacionItem: any, field: string) {
        let url = `${Common.END_POINT}/normalizaciones/data/${id}/update/${field}`;
        
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(normalizacionItem),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: boolean) => {
            this.Get();
        })
    }
}